import React from 'react';
import CustomImage from '../../components/custom-image';
const OperationalExcellence = () => {
  return (
    <div className="accordion-body">
      <div className="content">
        <div className="two-columns">
          <div className="left-text">
            <p>
              We consistently strive to improve our operations, integrate our businesses through the value chain and
              optimise our performance through operational efficiencies and innovative technological solutions. We also
              employ these tools to ensure sustainable operations and focus on delivering a positive impact for all our
              stakeholders and, more broadly, the society as a whole.
            </p>
          </div>
          <div className="right-image">
            <div className="desktop-img">
              <CustomImage className="custom-image"  imageName="investment-fcf-post.png" alt="FCF Post Capex" maxWidth="768" />
            </div>
            <div className="mobile-img">
              <CustomImage className="custom-image"  imageName="investment-fcf-post-mobile.png" alt="FCF Post Capex" maxWidth="768" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OperationalExcellence;
